import { useCallback, type MouseEvent } from "react";
import type { ObjectAssetInfo } from "../../api";
import { ModelThumbnail } from "./ModelThumbnail";

export function ModelCard({
  model,
  onDragStart,
}: {
  model: ObjectAssetInfo;
  onDragStart: (model: ObjectAssetInfo, e: MouseEvent) => void;
}) {
  const handleMouseDown = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      onDragStart(model, e);
    },
    [model, onDragStart],
  );

  return (
    <div
      className="group relative h-full overflow-hidden rounded-md border border-sands-200 bg-white cursor-grab active:cursor-grabbing hover:border-healing-300 hover:shadow-md transition-all select-none"
      onMouseDown={handleMouseDown}
      draggable={false}
      title={`${model.name} — drag into the scene to place`}
    >
      <ModelThumbnail model={model} />
      <p className="pointer-events-none absolute inset-x-0 bottom-0 truncate bg-gradient-to-t from-white via-white/90 to-transparent px-1 pb-0.5 pt-3 text-[10px] font-medium leading-tight text-sands-700">
        {model.name}
      </p>
    </div>
  );
}
